import { render } from "./ResultsForm.vue?vue&type=template&id=4d35195a&scoped=true"
import script from "./ResultsForm.vue?vue&type=script&lang=js"
export * from "./ResultsForm.vue?vue&type=script&lang=js"

import "./ResultsForm.vue?vue&type=style&index=0&id=4d35195a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d35195a"]])

export default __exports__